export default __webpack_public_path__ + "static/media/480_dummy2016-sprachunterricht01-de.b88f83f1.png";